import(/* webpackMode: "eager" */ "/home/runner/work/seethespin/seethespin/src/app/error.tsx");
